// Mirror BE rules in apps/api/internal/auth — keep in sync if BE changes.
export interface PasswordRule {
  id: string;
  label: string;
  test: (v: string) => boolean;
}

export const PASSWORD_RULES: PasswordRule[] = [
  { id: "length", label: "Tối thiểu 8 ký tự", test: (v) => v.length >= 8 },
  { id: "upper", label: "Có ít nhất 1 chữ hoa", test: (v) => /[A-Z]/.test(v) },
  { id: "digit", label: "Có ít nhất 1 chữ số", test: (v) => /\d/.test(v) },
];

export function isPasswordValid(v: string): boolean {
  return PASSWORD_RULES.every((r) => r.test(v));
}

export function countPassedRules(v: string): number {
  return PASSWORD_RULES.filter((r) => r.test(v)).length;
}
